<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>
    <template v-if="vettingCompleteModalShow">
      <app-modal
          :modal-id="modalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Vetting Completion") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">
              <label class="col-sm-4 mb-sm-0">Select Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="vetting.date"
                         placeholder="Select Date"
              />
              <label class="col-sm-4 mb-sm-0">Screening Officer Signature</label>
              <VueSignaturePad
                  id="signature"
                  width="100%"
                  height="150px"
                  ref="signaturePad"
                  :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
              />

              <div class="form-group">
                <label>{{ $t("Send assessment to director") }}</label>
                <app-input
                    type="select"
                    :placeholder="$t('select_user')"
                    :list="users"
                    v-model="select_user"
                    :required="true"
                />
                <div class="mt-2 d-flex col-12 justify-content-end align-items-center">
                  <button @click.prevent="undo" class="btn btn-danger mr-2">Undo</button>
                  <button @click.prevent="submit" class="btn btn-success mr-5">Save</button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal(modalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
    <template v-if="assignToDirectorModal">
      <app-modal
          :modal-id="assignToDirectorModalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal(assignToDirectorModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Director Signature") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">

              <div class="col-12">
                <label class="col-sm-12 mb-sm-0">Date</label>
                <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                           type="date"
                           v-model="vetting.director_signature_date"
                           placeholder="Select Date"
                />
                <label class="col-sm-12 mb-sm-0">Director Signature</label>
                <VueSignaturePad
                    id="signature"
                    width="100%"
                    height="150px"
                    ref="signaturePad"
                    :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                />
                <div class="mt-2 d-flex  justify-content-end align-items-center">
                  <button @click.prevent="undo" class="btn btn-danger mr-2">Undo</button>
                  <button @click.prevent="saveDirector" class="btn btn-success mr-5">Save</button>
                </div>
              </div>
              </div>
            </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal(assignToDirectorModalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
    <template v-if="assignToUserModal">
      <app-modal
          :modal-id="assignToUserModalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal(assignToUserModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Assign to user") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">

              <div class="form-group">
                <label>{{ $t("Select user to assign screening") }}</label>
                <app-input
                    type="select"
                    :placeholder="$t('select_user')"
                    :list="users"
                    v-model="select_user"
                    :required="true"
                />
                <div class="mt-2 d-flex col-12 justify-content-end align-items-center">
                  <button @click.prevent="assignToUser" class="btn btn-success mr-5">Save</button>
                </div>
              </div>


              </div>
            </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal(assignToUserModalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
    <template v-if="screeningCheckPointModal">
      <app-modal
          :modal-id="screeningCheckPointModalId"
          modal-alignment="top"
          modal-size="large"
          @close-modal="closeModal(screeningCheckPointModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Screening Checklists") }}</h5>
          <hr>
          <div>
            <el-button type="primary" @click="openCandidateDetail(rowData)">
              Attach Files
            </el-button>

            <el-button
                type="success"
                @click.prevent="getApplicantFiles">
              Refresh Files
            </el-button>
          </div>


          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">
              <div class="d-flex flex-wrap">
                <div
                    class="form-group-sm checklist-item"
                    v-for="(checkList, index) in localChecklists"
                    :key="index"
                >
                  <!-- Checklist Form Inputs -->
                  <label>{{ checkList.check_point }} <b>Due: {{checkList.screening_type === 'limited' ? rowData.limited_screening_due_date: rowData.complete_screening_due_date}} </b></label>
                  <app-input type="text" hidden :disabled="true" v-model="checkList.check_point" :required="true" />
                  <app-input type="date" :placeholder="$t('date')" v-model="checkList.date" :required="true" />
                  <app-input type="text" :placeholder="$t('Remarks')" v-model="checkList.comments" :required="true" />

                  <!-- File Selection Dropdowns -->
                  <div v-for="(file, fileIndex) in checkList.screening_checkList_files" :key="fileIndex" class="d-flex align-items-center">
                    <app-input
                        type="select"
                        :list="availableFiles(checkList)"
                        :placeholder="$t('screeningCheckListFiles')"
                        v-model="checkList.screening_checkList_files[fileIndex]"
                        :required="true"
                        class="flex-grow-1"
                    />
                    <button class="btn btn-link text-danger p-0 ml-2" @click="removeFile(checkList, fileIndex)" title="Remove">
                      ❌
                    </button>
                  </div>


                  <!-- Add File Button -->
                  <button class="btn btn-primary btn-sm mt-2" @click="addFileSelection(checkList)" type="button">
                    + Add File
                  </button>

                  <!-- Sample File Download Link -->
                  <a v-if="checkList.sample_file" :href="'/sample-documents/' + checkList.sample_file" target="_blank">
                    Download Sample File: {{ checkList.sample_file }}
                  </a>

                  <hr />
                </div>
              </div>

              <!-- Save Button -->
              <div class="mt-2 d-flex col-12 justify-content-end align-items-center">
                <button @click.prevent="saveScreeningChecklist" class="btn btn-success mr-5">Save</button>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal(assignToDirectorModalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {SCREENING_SCHEDULE} from '../../../../Config/ScreeningAppUrl'
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {Candidate} from "@Views/Screening/utility/apiAgent";
import {mergeDateTime} from "@Views/Screening/utility/common/candidate";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import {GET_COMPANY_USERS} from "@/app/Config/ApiUrl";
import {APPLICANT_FILES} from "@/app/Config/ScreeningAppUrl";
import * as actions from "@/app/Config/ApiUrl";


export default {
  extends: CoreLibrary,
  name: "ScreeningInProgressCandidates",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      tableId: "advance-table",
      rowData: {},
      screeningChecklists: [],
      localChecklists: [],

      options: {
        name: "AdvanceTable",
        url: SCREENING_SCHEDULE,
        showHeader: true,
        columns: [
          {
            title: this.$t("Id"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${value.id}</span>`;
            },
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${this.$t(value.full_name)}</span>`;
            },
          },

          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("progress"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span>${value.completion_percentage}</span>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${value}</span>`;
            },
          },
          {
            title: this.$t("to_be_completed_by"),
            type: "custom-html",
            key: "complete_screening_due_date",
            modifier: (value) => {
              if (value){
                const date1 = new Date(value);
                const date2 = new Date();
                // One day in milliseconds
                const oneDay = 1000 * 60 * 60 * 24;
                // Calculating the time difference between two dates
                const diffInTime = date1.getTime() - date2.getTime();
                // Calculating the no. of days between two dates
                const diffInDays = Math.round(diffInTime / oneDay);

                if (diffInDays <= 20 && diffInDays >= 11) {
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;

                }
                else if(diffInDays <= 10) {
                  if (diffInDays < 1) {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        'Due Date Passed'
                    )}</span>`;
                  }
                  else {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        diffInDays+' Days left'
                    )}</span>`;
                  }

                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;
                }
              }else{
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                    'N/A'
                )}</span>`;
              }


            },
          },
          {
            title: this.$t("limited_screening_completed_by"),
            type: "custom-html",
            key: "limited_screening_due_date",
            modifier: (value) => {
              if (value){
                const date1 = new Date(value);
                const date2 = new Date();
                // One day in milliseconds
                const oneDay = 1000 * 60 * 60 * 24;
                // Calculating the time difference between two dates
                const diffInTime = date1.getTime() - date2.getTime();
                // Calculating the no. of days between two dates
                const diffInDays = Math.round(diffInTime / oneDay);

                if (diffInDays <= 20 && diffInDays >= 11) {
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;

                }
                else if(diffInDays <= 10) {
                  if (diffInDays < 1) {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        'Due Date Passed'
                    )}</span>`;
                  }
                  else {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        diffInDays+' Days left'
                    )}</span>`;
                  }

                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;
                }
              }else{
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                    'N/A'
                )}</span>`;
              }


            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Screening Type"),
            type: "custom-html",
            key: "screening_type",
            modifier: (value) => {
              return `<span>${this.$t(value??'Internal')}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "file-plus",
            type: "none",
          },
          {
            title: this.$t("screening_checklists"),
            icon: "activity",
            type: "none",
          },
          {
            title: this.$t("assign_to_user"),
            icon: "user",
            type: "none",
          },
          {
            title: this.$t("download_full_screening_report"),
            icon: "file-plus",
            type: "none",
          },
          // {
          //   title: this.$t("download_limited_screening_report"),
          //   icon: "file-plus",
          //   type: "none",
          // },
          {
            title: this.$t("forward_to_director"),
            icon: "arrow-right",
            type: "none",
          },
          {
            title: this.$t("complete_vetting"),
            icon: "file-plus",
            type: "none",
          },
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      modalId: "vetting_complete_modal",
      vettingCompleteModalShow: false,
      assignToDirectorModalId: "assign_to_director",
      screeningCheckPointModalId: "screening_checklist",
      assignToUserModalId: "assign_to_user_modal",
      assignToDirectorModal: false,
      assignToUserModal: false,
      screeningCheckPointModal: false,
      vetting: {},
      users: [],
      select_user: '',
      applicantFiles: [],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.getUsers();
  },
  methods: {
    openCandidateDetail(rowData) {
      if (!rowData || !rowData.company_id || !rowData.applicant_id) {
        console.error("Invalid rowData:", rowData);
        return;
      }

      const url = `/candidate-detail/${rowData.company_id}/${rowData.applicant_id}?tab=Upload%20Documents`;
      window.open(url, "_blank");
    },
    mergeDateTime,
    getPageTitle() {
      let pageTitle = 'Candidates Screening In Progress';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("view")) {
        window.location.replace(`/candidate-detail/${rowData.company_id}/${rowData.applicant_id}`);
      } else if (actionObj.title == this.$t("download_full_screening_report")) {
        window.open('/generate-candidate-screening-report/full_screening?applicant_id='+rowData.applicant_id, '_blank');
      } else if (actionObj.title == this.$t("download_limited_screening_report")) {
        window.open('/generate-candidate-screening-report/limited_screening?applicant_id='+rowData.applicant_id, '_blank');
      } else if (actionObj.title == this.$t("forward_to_director")) {
        this.vettingCompleteModalShow = true;
      } else if (actionObj.title == this.$t("complete_vetting")) {
        this.assignToDirectorModal = true;
      }else if (actionObj.title == this.$t("assign_to_user")) {
        this.assignToUserModal = true;
      }else if (actionObj.title == this.$t("screening_checklists")) {
        this.getApplicantFiles();
        this.screeningCheckPointModal = true;
      }
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal('hide');
      this.vettingCompleteModalShow = false;
      this.screeningCheckPointModal = false;
      this.assignToUserModal = false;
      this.assignToDirectorModal = false;

    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    getUsers() {
      axiosGet(GET_COMPANY_USERS)
          .then((res) => {
            this.users = res.data;
          })
          .catch((error) => {

          });
    },

    assignToUser(){
      const body = {
        assigned_to: this.select_user,
        status: 'forwarded_to_user'
      };
      Candidate.postVetting(this.rowData.id, body)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            console.error(error);
            this.$toastr.s(error.data.message);

          })
          .finally(() => {
            this.closeModal(this.assignToUserModalId);
          });

    },
    saveScreeningChecklist(){
      Candidate.postScreeningChecklist(this.rowData.applicant_id, this.localChecklists)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {

          })
          .finally(() => {
            this.closeModal(this.screeningCheckPointModalId);
          });
    },
    submit() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      const body = {
        signature: data,
        completed_at: this.vetting.date,
        director_id: this.select_user,
        status: 'forwarded_to_director'
      };
      Candidate.postVetting(this.rowData.id, body)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.closeModal(this.modalId);
          });
    },
    saveDirector() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      const body = {
        director_signature: data,
        director_signature_date: this.vetting.director_signature_date,
        status: 'completed'
      };
      Candidate.postVetting(this.rowData.id, body)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.closeModal(this.assignToDirectorModalId);
          });
    },

    getApplicantFiles(){
      let url = `${APPLICANT_FILES}`;
      url +=  `?id=${this.rowData.applicant_id}&per_page=200`;
      this.axiosGet(url)
          .then((response) => {
            const files = response.data.data;
            this.applicantFiles = files.map(function(file) {
              return {
                id: file.id, // Use file.id for the id property
                value: `${file.file_name} (${file.type})` // Combine file_name and file_type for the value
              };
            });
          })
          .catch(({ response }) => {

          })
          .finally(() => {

          });
    },
    addFileSelection(checkList, index) {
      // Ensure screening_checkList_files is initialized as an array
      if (!Array.isArray(checkList.screening_checkList_files)) {
        this.$set(checkList, 'screening_checkList_files', []);
      }
      // Add a new empty entry for file selection
      checkList.screening_checkList_files.push("");
    },
    availableFiles(checkList) {
      // Ensure screening_checkList_files exists and normalize its IDs to integers
      const selectedFiles = new Set(checkList.screening_checkList_files.map(Number));

      // Map over applicantFiles and add a `disabled` attribute for selected files
      return this.applicantFiles.map((file) => ({
        ...file,
        disabled: selectedFiles.has(file.id), // Disable if the file is selected
      }));
    },

    removeFile(checkList, fileIndex) {
      checkList.screening_checkList_files.splice(fileIndex, 1);
    },


  },
  computed:{
    today(){
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = today.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }
  },
  watch: {
    rowData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.localChecklists = JSON.parse(JSON.stringify(newVal.screeningChecklists || []));
      }
    }
  },

};
</script>
<style scoped>
.checklist-item {
  width: 48%;  /* Each item takes half of the row */
  min-width: 300px; /* Ensures proper form width */
  margin-right: 2%;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .checklist-item {
    width: 100%; /* Stacks items on smaller screens */
    margin-right: 0;
  }
}

</style>